import React from "react";
import { observer } from "mobx-react";
import TimeElapsed from "../Components/Request/TimeElapsed";

const SDKConnections = observer((props) => {
  return (
    <>
        <div className="row">
        <div className="col-md-12">
        
          <div className="card mb-4">
            <div className="card-body">

              <div className="row">
                <div className="col-md-12">
                  {props.store.SessionStore.connectedContextSdks.length > 0 ? (
                    <div className="table">
                        <table className="table">
                        <thead>
                            <tr>
                                <th>Connection Id</th>
                                <th className="text-center">Started</th>
                                <th className="text-center">Redactions Refreshed</th>
                            </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                        {props.store.SessionStore.connectedContextSdks.map((connection) => (             
                            <tr key={`detail_${connection.clientId}`}>
                            <td>{connection.clientId}</td>
                            <td className="text-center"><TimeElapsed since={JSON.parse(connection.data).started} /></td>                      
                            <td className="text-center"><TimeElapsed since={JSON.parse(connection.data).redactionsLastUpdated} /></td>
                            </tr>    
                            ))}          
                        </tbody> 
                        </table>
                    </div>
                  ) : (
                    <>
                      <div className="card shadow-none bg-lighter border border-secondary">
                        <div className="card-body text-center mt-3">
                          <p>There are no API servers connected</p>         
                          <p>Ensure the SDK is setup to connect to bucket id: {props.store.SessionStore.getBucketSidFromUrl()}</p>          
                        </div>
                      </div>
                    </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default SDKConnections;
